
import React from 'react';
import './EtoileAvis.css';

function StarRating({ rating, setRating }) {
  return (
    <div id='etoiles'>
      {[1, 2, 3, 4, 5].map((star) => {
        return (  
          <span
            key={star}
            className='start'
            style={{
              cursor: 'pointer',
              color: rating >= star ? 'gold' : 'gray',
              fontSize: `50px`,
            }}
            onClick={() => {
              setRating(star);
            }}
          >
            {' '}
            ★{' '}
          </span>
        )
      })}
    </div>
  )
}

export default StarRating;